import { navLinks, tagWall } from "@/mocks/home";

export default function SiteFooter() {
  const year = new Date().getFullYear();

  return (
    <footer className="w-full bg-primary-800 text-background-100">
      <div className="w-full px-4 md:px-8 py-12 md:py-14">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 md:gap-6">
          <div className="md:col-span-1">
            <div className="flex items-center gap-2.5">
              <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-50 text-primary-700">
                <i className="ri-fire-fill text-lg" />
              </span>
              <span className="font-heading font-black text-xl text-background-50">黑料入口</span>
            </div>
            <p className="mt-4 text-sm text-background-200 leading-relaxed">
              一个专注入口与话题聚合的单页导航站。防走失、防屏蔽、防失联，
              收藏这一页，换个入口继续吃瓜看爆料。
            </p>
          </div>

          <div>
            <h3 className="font-heading font-bold text-base text-background-50">站内分区</h3>
            <div className="mt-4 flex flex-col gap-2.5">
              {navLinks.map((link) => (
                <a
                  key={link.id}
                  href={`#${link.id}`}
                  className="text-sm text-background-200 hover:text-background-50 transition-colors w-fit"
                >
                  {link.label}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h3 className="font-heading font-bold text-base text-background-50">常用入口</h3>
            <div className="mt-4 flex flex-col gap-2.5">
              <a href="#entries" className="text-sm text-background-200 hover:text-background-50 transition-colors w-fit">
                主站入口
              </a>
              <a href="#entries" className="text-sm text-background-200 hover:text-background-50 transition-colors w-fit">
                备用线路 B
              </a>
              <a href="#entries" className="text-sm text-background-200 hover:text-background-50 transition-colors w-fit">
                镜像线路 03
              </a>
              <a href="#entries" className="text-sm text-background-200 hover:text-background-50 transition-colors w-fit">
                移动专线
              </a>
            </div>
          </div>

          <div>
            <h3 className="font-heading font-bold text-base text-background-50">热门标签</h3>
            <div className="mt-4 flex flex-wrap gap-2">
              {tagWall.slice(0, 8).map((tag) => (
                <a
                  key={tag}
                  href="#topics"
                  className="px-2.5 py-1 rounded-md bg-background-50/10 text-xs font-label text-background-100 hover:bg-background-50/20 transition-colors"
                >
                  #{tag}
                </a>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-50/15">
          <p className="text-xs text-background-200/80 leading-relaxed">
            免责声明：本站为入口导航与话题聚合的演示页面，展示内容均为示例文案，不代表任何真实事件、
            人物或立场。页面不存储、不制作、不分发任何资源，入口按钮与状态板仅作排版演示之用。
          </p>
          <div className="mt-5 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
            <p className="text-xs text-background-200/80">
              © {year} 黑料入口 · 备用入口 防走失 新地址
            </p>
            <div className="flex items-center gap-4">
              <a href="#faq" className="text-xs text-background-200 hover:text-background-50 transition-colors">
                免责声明
              </a>
              <a href="#tips" className="text-xs text-background-200 hover:text-background-50 transition-colors">
                使用帮助
              </a>
              <a href="#top" className="text-xs text-background-200 hover:text-background-50 transition-colors">
                回到顶部
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}